module.exports = __webpack_public_path__ + "components/flag/static/square/kz-f2c68f2c7d64ed1f7ced1907daaebaf9.svg";